import React, { useState } from "react"
import { Header, Flex, Divider, Text } from "@jjordy/layout"
import styled from "styled-components"
import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa"
import posed from "react-pose"
import Spacer from "./Elements/Spacer"

const Toggle = posed.div({
  closed: {
    height: 0,
    opacity: 0
  },
  open: {
    height: "auto",
    opacity: 1
  }
})

const OpenIcon = styled(FaChevronCircleUp)`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${(props) => props.theme.colors.info};
`

const CloseIcon = styled(FaChevronCircleDown)`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${(props) => props.theme.colors.info};
`

const StyledToggle = styled(Toggle)`
  overflow: hidden;
  width: 100%;
`

export interface TogglePanelProps {
  title?: string
  children?: React.ReactNode
  onOpen?: () => void
  onClose?: () => void
  subheader?: string
}

export default function TogglePanel({
  title,
  children,
  onOpen = () => {
    return
  },
  onClose = () => {
    return
  },
  subheader
}: TogglePanelProps) {
  const [display, toggleDisplay] = useState(false)
  return (
    <Flex direction="column" px={1}>
      <Flex
        align="center"
        pt={0.5}
        wrap="wrap"
        role="button"
        style={{ userSelect: "none", cursor: "pointer" }}
        onClick={() => {
          toggleDisplay(!display)
          if (!display === false) {
            onClose()
          }
          if (!display === true) {
            onOpen()
          }
        }}
      >
        <Header m={0} mr={1} fg="grey" size={1}>
          {title}
        </Header>
        {display ? <OpenIcon /> : <CloseIcon />}
        <Spacer />
        {subheader && (
          <Text small m={0} ml={1} fg="grey">
            {subheader}
          </Text>
        )}
      </Flex>

      {display && <Divider />}
      <StyledToggle pose={display ? "open" : "closed"}>{children}</StyledToggle>
    </Flex>
  )
}
